module.exports = __webpack_public_path__ + "img/excel.2a6cd11f.svg";